import {set} from "lodash/object";
import {Kind} from "graphql";
import Thumbor from "thumbor";

// TODO add Thumbnail type {size, url}
export default function thumbs(field, pathField = 'path', config) {

    const urlGenerator = (size, build, path, ctx) => {
        const thumborImage = new Thumbor(process.env.THUMBOR_SECURITY_KEY, process.env.THUMBOR_URL_SERVER);
        return {
            size,
            url: build(thumborImage.setImagePath(
                `${ctx.municipality.alias}.${process.env.DOSVIT_DOMAIN || 'dosvit.org.ua'}/storage/${ctx.application.name}/${path}`
            )).buildUrl()
        }
    };

    return ({typeDefs, resolvers}) => {
        const path = field.split('.');
        if (path.length < 2) {
            path.unshift('Query')
        }

        set(resolvers, path.join('.'), function (_, args, ctx, info) {
            if (Array.isArray(config)) {
                return config
                    .filter(({size}) => {
                        if (args.size) {
                            return Array.isArray(args.size) ? args.size.includes(size) : args.size === size;
                        }
                        return true;
                    })
                    .map(({size, build}) => urlGenerator(size, build, _[pathField], ctx));
            }
            return urlGenerator(config.size, config.build, _[pathField], ctx);
        })

        const directive = {
            kind: Kind.DIRECTIVE,
            name: {kind: Kind.NAME, value: 'requires'},
            arguments: [{
                kind: Kind.ARGUMENT, name: {kind: Kind.NAME, value: 'fields'}, value:
                    {
                        kind: Kind.ARGUMENT,
                        name: {kind: Kind.NAME, value: 'handler'},
                        value: {kind: 'StringValue', value: pathField, block: false}
                    }
            }]
        }
        const typeIndex = typeDefs.definitions.findIndex(d => d.name?.value === path[0]);
        const fieldIndex = typeDefs.definitions[typeIndex].fields.findIndex(f => f.name?.value === path[1]);
        typeDefs.definitions[typeIndex].fields[fieldIndex].directives.push(directive)

        return {typeDefs, resolvers};
    }
}
